export const TRANSFER_IFRAME_EVENT = {
  CLOSE_REQUEST: "TRANSFER_CLOSE_REQUEST",
  SUCCESS: "TRANSFER_SUCCESS",
  RESULT: "TRANSFER_RESULT",
  DIRTY_CHANGED: "TRANSFER_DIRTY_CHANGED",
  PARENT_CLOSE_ATTEMPT: "TRANSFER_PARENT_CLOSE_ATTEMPT",
} as const;

type TransferIframeEventType =
  (typeof TRANSFER_IFRAME_EVENT)[keyof typeof TRANSFER_IFRAME_EVENT];

type TransferIframeMessage<T extends TransferIframeEventType> = {
  type: T;
  payload?: Record<string, unknown>;
};

const postToParent = <T extends TransferIframeEventType>(
  message: TransferIframeMessage<T>,
) => {
  if (window.parent === window) return;

  window.parent.postMessage(message, "*");
};

export const sendTransferCloseRequest = () => {
  postToParent({
    type: TRANSFER_IFRAME_EVENT.CLOSE_REQUEST,
  });
};

export const sendTransferSuccess = (payload?: Record<string, unknown>) => {
  postToParent({
    type: TRANSFER_IFRAME_EVENT.SUCCESS,
    payload,
  });
};

export const sendTransferResult = (payload: {
  status: "success" | "partial_success" | "error";
  message: string;
  transfersCount?: number;
  successCount?: number;
  failedCount?: number;
  clientId?: string;
}) => {
  postToParent({
    type: TRANSFER_IFRAME_EVENT.RESULT,
    payload,
  });
};

export const sendTransferDirtyChanged = (isDirty: boolean) => {
  postToParent({
    type: TRANSFER_IFRAME_EVENT.DIRTY_CHANGED,
    payload: { isDirty },
  });
};
